import { createAction } from 'redux-actions';

const bigpointsActions = {
  BIG_POINTS_TOGGLE: 'BIG_POINTS_TOGGLE',
};

const actionCreators = {
  toggleBigpoint: createAction(bigpointsActions.BIG_POINTS_TOGGLE),
};

export { bigpointsActions as types, actionCreators };
